var React = require('react');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step3;
var { $input, $datePicker, $simpleSelect } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');

class ContactInformation extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    componentDidMount() {
        if (memberTypeChecker.addressTypeIsHomeByDefault(this.props.appState.appType)) {
            this.props.updateStepState('addressType', 'HOME');
        }

        if (!memberTypeChecker.internationalAddressFields(this.props.appState.appType)) {
            this.props.updateStepState('country', 'USA');
        }
    }

    bindFunctions() {
        this.getAddressFieldsMarkup = this.getAddressFieldsMarkup.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    getAddressFieldsMarkup() {

        const businessNameMarkup = this.props.stepState.addressType !== 'HOME' ? <div className={"field-wrap"}>
            <span>{labels.step3.businessName}</span>
            <$input name="companyName" value={this.props.stepState.companyName} onChange={this.handleInputChange} />
        </div> : null;

        const addressTypeMarkup = memberTypeChecker.addressTypeIsHomeByDefault(this.props.appState.appType)
            ? <input value={this.props.stepState.addressType} name="addressType" onChange={this.handleInputChange} disabled={true} />
            : <$simpleSelect value={this.props.stepState.addressType} name="addressType" onChange={this.handleInputChange} validations={[validationFunctions.required]} />;

        const countryMarkup = memberTypeChecker.internationalAddressFields(this.props.appState.appType)
            ? <$simpleSelect
                value={this.props.stepState.country}
                name="country"
                onChange={this.handleInputChange}
                selectdatafunction={selectableDataFunctions.getApiCountriesFromAllCountries}
                validations={[validationFunctions.required]} />
            : <input value={this.props.stepState.country} name="country" onChange={this.handleInputChange} disabled={true} />;

        // this is a workaround to force our validation library to handle the dynamic set of validation functions
        const stateMarkup = ['USA', 'CAN'].includes(this.props.stepState.country) ?
            [<$simpleSelect key={'state-field-required'}
                name="state"
                value={this.props.stepState.state}
                country={this.props.stepState.country}
                selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                onChange={this.handleInputChange}
                validations={[validationFunctions.required]} />, null] :
            [null, <$simpleSelect key={'state-field-not-required'}
                name="state"
                value={this.props.stepState.state}
                country={this.props.stepState.country}
                selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                onChange={this.handleInputChange} />];


        const zipMarkup = ['USA', 'CAN'].includes(this.props.stepState.country) ? [<$input key={'zip-field-required'}
            name="zip"
            value={this.props.stepState.zip}
            country={this.props.stepState.country}
            onChange={this.handleInputChange}
            validations={[validationFunctions.required]} />, null] :
            [null, <$input key={'zip-field-not-required'}
                name="zip"
                value={this.props.stepState.zip}
                country={this.props.stepState.country}
                onChange={this.handleInputChange}
                validations={[]} />];


        if (memberTypeChecker.internationalAddressFields(this.props.appState.appType)) {
            return <div>
                <h4>{labels.step3.internationalAddress}</h4>

                <div className={"field-wrap"}>
                    <span>{labels.step3.country}</span>
                    {countryMarkup}
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.addressType}</span><br />{addressTypeMarkup}
                </div>

                {businessNameMarkup}

                <div className={"field-wrap"}>
                    <span>{labels.step3.internationalAddress}</span>
                    <$input name="addressLine1" value={this.props.stepState.addressLine1} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <span>{labels.step3.addressLine2}</span>
                    <$input name="addressLine2" value={this.props.stepState.addressLine2} onChange={this.handleInputChange} />
                </div>
                <div className={"field-wrap"}>
                    <span>{labels.step3.addressLine3}</span>
                    <$input name="addressLine3" value={this.props.stepState.addressLine3} onChange={this.handleInputChange} />
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.city}</span>
                    <$input name="city" value={this.props.stepState.city} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.state}</span>
                    {stateMarkup}
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.postalCode}</span>
                    {zipMarkup}
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.phoneLocation}</span>
                    <$simpleSelect value={this.props.stepState.phoneLocation} selectoptions="phoneLocation" name="phoneLocation" onChange={this.handleInputChange} disabled={this.props.stepState.phoneLocation} validations={[validationFunctions.required]}></$simpleSelect>
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.phoneNumber}</span>
                    <$input name="phoneNumber" value={this.props.stepState.phoneNumber} onChange={this.handleInputChange} validations={[validationFunctions.required, validationFunctions.phoneLength]} />
                </div>

            </div>;
        } else {
            return <div>
                <h4>{labels.step3.usBasedAddress}</h4>

                <div className={"field-wrap"}>
                    <span>{labels.step3.country}</span>
                    {countryMarkup}
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.addressType}</span>
                    {addressTypeMarkup}
                </div>

                {businessNameMarkup}

                <div className={"field-wrap"}>
                    <span>{labels.step3.address}</span>
                    <$input name="addressLine1" value={this.props.stepState.addressLine1} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <span>{labels.step3.addressLine2}</span>
                    <$input name="addressLine2" value={this.props.stepState.addressLine2} onChange={this.handleInputChange} />
                </div>
                <div className={"field-wrap"}>
                    <span>{labels.step3.addressLine3}</span>
                    <$input name="addressLine3" value={this.props.stepState.addressLine3} onChange={this.handleInputChange} />
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.city}</span>
                    <$input name="city" value={this.props.stepState.city} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.state}</span>
                    {stateMarkup}
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.zip}</span>
                    <$input name="zip" value={this.props.stepState.zip} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.phoneLocation}</span>
                    <$simpleSelect value={this.props.stepState.phoneLocation} selectoptions="phoneLocation" name="phoneLocation" onChange={this.handleInputChange} validations={[validationFunctions.required]}></$simpleSelect>
                </div>

                <div className={"field-wrap"}>
                    <span>{labels.step3.phoneNumber}</span>
                    <$input name="phoneNumber" value={this.props.stepState.phoneNumber} onChange={this.handleInputChange} validations={[validationFunctions.required, validationFunctions.phone]} />
                </div>

            </div>;
        }
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    render() {
        return <div className={"contact-information-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step3.contactInformation}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            {this.getAddressFieldsMarkup()}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = ContactInformation;